import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import rs from "./custom-event-data.js";
import ls from "./custom-event-property-data.js";
import is from "./filter-set.js";
import ui from "./in-app-message-click-data.js";
import ns from "./purchase-data.js";
import us from "./purchase-property-data.js";
import ur from "./push-click-data.js";
import ot from "./trigger-events.js";
import { logger as E } from "../../../shared-lib/index.js";
import { getErrorMessage as si } from "../../util/error-utils.js";
var ri = /*#__PURE__*/function () {
  function ri(e, t) {
    _classCallCheck(this, ri);
    this.type = e, this.data = t, this.type = e, this.data = t;
  }
  _createClass(ri, [{
    key: "kc",
    value: function kc(e, t) {
      return ri._c[this.type] === e && (null == this.data || this.data.xc(t));
    }
  }, {
    key: "dt",
    value: function dt() {
      return {
        t: this.type,
        d: this.data ? this.data.dt() : null
      };
    }
  }], [{
    key: "sf",
    value: function sf(e, t) {
      var r = null;
      try {
        r = window.atob(e);
      } catch (t) {
        return E.info("Failed to unencode analytics id " + e + ": " + si(t)), !1;
      }
      return t === r.split("_")[0];
    }
  }, {
    key: "fromJson",
    value: function fromJson(e) {
      var t = e.type;
      var r = null;
      switch (t) {
        case ri._r.OPEN:
        case ri._r.qs:
          break;
        case ri._r.Rr:
          r = ns.fromJson(e.data);
          break;
        case ri._r.bc:
          r = us.fromJson(e.data);
          break;
        case ri._r.vr:
          r = ur.fromJson(e.data);
          break;
        case ri._r.pe:
          r = rs.fromJson(e.data);
          break;
        case ri._r.Ec:
          r = ls.fromJson(e.data);
          break;
        case ri._r.Qr:
          r = ui.fromJson(e.data);
      }
      return new ri(t, r);
    }
  }, {
    key: "qn",
    value: function qn(e) {
      var t,
        r = null;
      switch (e.t) {
        case ri._r.OPEN:
        case ri._r.qs:
          break;
        case ri._r.Rr:
          r = new ns(e.d);
          break;
        case ri._r.bc:
          t = e.d || {}, r = new us(t.id, is.qn(t.pf || []));
          break;
        case ri._r.vr:
          r = new ur(e.d);
          break;
        case ri._r.pe:
          r = new rs(e.d);
          break;
        case ri._r.Ec:
          t = e.d || {}, r = new ls(t.e, is.qn(t.pf || []));
          break;
        case ri._r.Qr:
          r = new ui(e.d);
      }
      return new ri(e.t, r);
    }
  }]);
  return ri;
}();
export { ri as default };
ri._r = {
  OPEN: "open",
  Rr: "purchase",
  bc: "purchase_property",
  vr: "push_click",
  pe: "custom_event",
  Ec: "custom_event_property",
  Qr: "iam_click",
  qs: "test"
}, ri._c = {}, ri._c[ri._r.OPEN] = ot.OPEN, ri._c[ri._r.Rr] = ot.Rr, ri._c[ri._r.bc] = ot.Rr, ri._c[ri._r.vr] = ot.vr, ri._c[ri._r.pe] = ot.pe, ri._c[ri._r.Ec] = ot.pe, ri._c[ri._r.Qr] = ot.Qr, ri._c[ri._r.qs] = ot.qs;